export default {
  layout: {
    default: [
      'ё 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'й ц у к е н г ш щ з х ъ \\',
      'ф ы в а п р о л д ж э',
      '{shift} я ч с м и т ь б ю . {shift}',
      '@ {space}',
    ],
    shift: [
      'Ё ! " № ; % : ? * ( ) _ +',
      'Й Ц У К Е Н Г Ш Щ З Х Ъ /',
      'Ф Ы В А П Р О Л Д Ж Э',
      '{shift} Я Ч С М И Т Ь Б Ю , {shift}',
      '@ {space}',
    ],
  },
};
